import { Modal, StatusBar, StyleSheet, TouchableOpacity, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { mvs } from 'react-native-size-matters';

import { CustomIcon } from '../../components/CustomIcon';
import CustomText from '../../components/CustomText';
import { AllPodcastGrid } from '../../components/Podcast';
import { ScreenLayout } from '../../components/ScreenLayout';
import { COLORS, DataState, IS_IOS } from '../../constants';
import { useAdjustedFontSize } from '../../hooks/useAdjustedFontSize';
import i18n from '../../localization/i18n';
import { PodcastModel } from '../../models';

export interface AllPodcastsModalScreenProps {
  visible: boolean;
  onRequestClose: () => void;
  podcastList: Partial<PodcastModel>[] | null;
  podcastListState: DataState;
  onPodcastPress: (podcastUrl: string) => void;
}

export default function AllPodcastsModalScreen({
  visible,
  onRequestClose,
  podcastList,
  podcastListState,
  onPodcastPress,
}: AllPodcastsModalScreenProps) {
  const insets = useSafeAreaInsets();

  // dynamic font sizes
  const titleFontSize = useAdjustedFontSize(mvs(25));
  const titleLineHeight = useAdjustedFontSize(mvs(30));

  return (
    <Modal
      visible={visible}
      animationType="slide"
      presentationStyle="fullScreen"
      statusBarTranslucent
      onRequestClose={() => onRequestClose()}
    >
      <StatusBar
        backgroundColor={COLORS.TRANSPARENT}
        barStyle="light-content"
        translucent
      />
      <ScreenLayout
        isPodcastModule
        headerStyle={IS_IOS && { marginTop: insets.top }}
        headerContents={
          <View style={styles.header}>
            <TouchableOpacity
              style={styles.backButton}
              onPress={onRequestClose}
              activeOpacity={0.7}
            >
              <View style={styles.backIconContainer}>
                <CustomIcon name="back" size={24} color={COLORS.WHITE} />
              </View>
            </TouchableOpacity>
            <CustomText
              style={[
                styles.title,
                {
                  fontSize: titleFontSize,
                  lineHeight: titleLineHeight,
                },
              ]}
              weight="Bold"
            >
              {i18n.t('podcast.all')}
            </CustomText>
          </View>
        }
      >
        <View style={styles.content}>
          <AllPodcastGrid
            podcastList={podcastList}
            podcastListState={podcastListState}
            onPodcastPress={onPodcastPress}
          />
        </View>
      </ScreenLayout>
    </Modal>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  backButton: {
    marginRight: mvs(5),
  },
  backIconContainer: {
    width: mvs(24),
    height: mvs(24),
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: COLORS.WHITE,
    flex: 1,
  },
  content: {
    flex: 1,
    alignItems: 'stretch',
  },
});
